import ComboBox from "../core/ComboBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";

const ProjectDropdown = ({
  projects = [],
  currentProjectId,
  currentProjectName,
  showDropdown,
  onToggle,
  onClose,
  onSelect,
  emptyLabel = "No Project",
  triggerClassName = "",
  triggerId,
}) => {
  const selectedProject = projects.find(
    (project) => String(project.project_id) === String(currentProjectId)
  );

  const displayName =
    selectedProject?.name ?? currentProjectName ?? emptyLabel;

  const selectedItems = selectedProject ? [selectedProject] : [];

  return (
    <div className="inline-select">
      <button
        type="button"
        id={triggerId}
        className={`inline-select-trigger${
          triggerClassName ? ` ${triggerClassName}` : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        {currentProjectId ? (
          <>
            <span
              className="inline-option-color"
              style={{
                backgroundColor:
                  selectedProject?.color || "var(--border-color)",
              }}
            />
            <span className="inline-select-text">{displayName}</span>
          </>
        ) : (
          <span className="inline-select-text">{emptyLabel}</span>
        )}
        <FontAwesomeIcon
          icon={faChevronDown}
          className="inline-select-chevron"
        />
      </button>
      {showDropdown && (
        <div className="inline-select-dropdown">
          <ComboBox
            data={projects}
            selected={selectedItems}
            valueKey="project_id"
            placeholder="Search projects..."
            searchTopic="project"
            formatData={(project) => (
              <div className="inline-option">
                <span
                  className="inline-option-color"
                  style={{
                    backgroundColor: project.color || "var(--border-color)",
                  }}
                />
                <span>{project.name}</span>
                {String(currentProjectId) === String(project.project_id) && (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="inline-option-check"
                  />
                )}
              </div>
            )}
            handleSelect={(projectId) => {
              onSelect(projectId);
              onClose();
            }}
            onRequestClose={onClose}
            inline={true}
          />
        </div>
      )}
    </div>
  );
};

export default ProjectDropdown;
